import {
  Box,
  Text,
  Link,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  List,
  ListItem,
  Image,
  Center,
  Input,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NextLink from "next/link";
import React, { useState, useEffect } from "react";
import {
  faFilePdf,
  faBars,
  faTable,
  faTruck,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/router";
import BaseLayout from "../../../components/base_layout";
import Loading from "../../../components/Loading";
import Pagination from "react-js-pagination";
import Route from "../../../components/common/route";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectFade, Navigation } from "swiper";
SwiperCore.use([Navigation, EffectFade]);

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import { GetCookie } from "../../../provider/common";
//견적바구니 개수 추가
import { useRecoilState } from "recoil";
import { quoteCntState } from "../../../atoms/state";

export default function Category() {
  const router = useRouter();
  // url에 맨 마지막 카테고리 숫자
  const code = router.query.code;
  const manufacturer = router.query.manufacturer;
  const [keyword, setKeyword] = useState("");
  const [isShow, setIsShow] = useState(true);
  const [loadingShow, setLoadingShow] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [manufacturerGroup, setManufacturerGroup] = useState([]);
  const [data, setData] = useState("");
  const [categoryInfo, setCategoryInfo] = useState([]);
  const [noneSearchShow, setNoneSearchShow] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
  const [block, setBlock] = useState(true);
  const [userType, setUserType] = useState("");
  const [btnActive, setBtnActive] = useState("square");
  const [isLoginCheck, setIsLoginCheck] = useState("");
  const [quoteCnt, setQuoteCnt] = useRecoilState(quoteCntState);

  useEffect(() => {
    getData();
    handleLoginCheck();
  }, [page]);

  const getData = async () => {
    if (keyword) {
      var URL = `${
        process.env.PANDA_API_URL
      }/api/mallshop/category?ca_id=${code}&page=${page}&offset=${perPage}&keyword=${encodeURIComponent(
        keyword
      )}`;
    } else {
      // Raspberry pi 4 검색용
      if (
        router.query.categorykeyword !== undefined &&
        router.query.categorykeyword !== ""
      ) {
        setKeyword(router.query.categorykeyword);
        var URL = `${process.env.PANDA_API_URL}/api/mallshop/category?ca_id=${code}&page=${page}&offset=${perPage}&keyword=${router.query.categorykeyword}`;
        // URL 지우기
        router.query.categorykeyword = "";
      } else {
        var URL = `${process.env.PANDA_API_URL}/api/mallshop/category?ca_id=${code}&page=${page}&offset=${perPage}`;
      }
    }
    await getUrlLists(URL);
  };

  const getUrlLists = async (URL) => {
    const axios = require("axios").default;
    setLoadingShow(true);
    try {
      let res = await axios.get(URL, {
        headers: {
          Authorization: "Bearer " + (await GetCookie("token")),
        },
      });

      if (res.data.msg == "해당 카테고리 아이템이 없습니다.") {
        setLoadingShow(false);
        setNoneSearchShow(true);
        setBlock(false);
        return;
      }
      if (res.data.data) {
        setSearchShow(true);
        setCategoryInfo(res.data.data.category_info.reverse());
        setManufacturerGroup(res.data.data.category_brand);
        setTotalCount(res.data.data.total_rows);
        setData(res.data.data.items);
        setLoadingShow(false);
        setBlock(true);
        setNoneSearchShow(false);
        setUserType(res.data.data.userMember);
      }
    } catch (e) {
      setLoadingShow(false);
    }
  };

  // manufacturer 리스트 전채 보여주고 닫는 함수
  const _showAlllist = () => {
    setIsShow(!isShow);
  };

  // 검색어 버튼 누를 경우
  const searchKeyword = (e) => {
    // 검색어 버튼을 누를 경우 기존에 저장되었던 페이지는 1로 초기화 한다.
    setPage(1);
    getData();
  };

  // 검색어 저장
  const saveKeyword = (e) => {
    setKeyword(e.target.value);
  };

  // 현재 페이지 나타내는 함수
  const handlePageChange = (page) => {
    window.scrollTo(0, 400);
    setPage(page);
  };

  const OnEnter = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await searchKeyword();
    }
  };

  const handleLoginCheck = async () => {
    const isLogin = await GetCookie("isLogin");
    setIsLoginCheck(isLogin);
  };

  const combineBotAsked = async (isLoginCheck, data) => {
    // 로그인이 되어있지 않더라도 상세를 볼수 있게 한다. 이유는 구글 크롬에서 가져오기 위함
    const basePath = "/parts/inventory/" + data.it_id;
    router.push(basePath);
  };

  // 몰뷰로 이동할 것인가? 컴바인봇 견적 문의하기로 할 것이냐?
  const isShoppingmallOrCombineBot = async (isLoginCheck, datum) => {
    if (datum.it_soldout === 2) {
      await combineBotAsked(isLoginCheck, datum);
    } else {
      //쇼핑몰소개
      router.push(`/parts/mallview/${datum.it_id}`);
    }
  };

  return (
    <BaseLayout>
      <Loading loadingShow={loadingShow} />
      <Box className="market_wrap" mt="15px">
        <Box className={searchShow ? "" : "search-hidden"}>
          <Box className="category_container">
            <Box className="search_filter_box category_filter_box">
              <Box
                className={
                  "search__filter_title category_page_wrap " +
                  (isShow
                    ? "filter-title--collapsed"
                    : "filter-title--expanded")
                }
              >
                {manufacturerGroup.length > 20 ? (
                  isShow ? (
                    <>
                      <h3 className="category_page_title">
                        <Breadcrumb
                          fontWeight="medium"
                          mt="1"
                          paddingBottom="4"
                        >
                          <BreadcrumbItem>
                            <BreadcrumbLink
                              className="category-nav__list"
                              href="/"
                            >
                              홈
                            </BreadcrumbLink>
                          </BreadcrumbItem>
                          {categoryInfo.length > 0
                            ? categoryInfo.map((el) => (
                                <BreadcrumbItem isCurrentPage>
                                  <BreadcrumbLink className="category-nav__list">
                                    <Link
                                      href={`/parts/mallcategory/${+el.id}`}
                                    >
                                      {el.name}
                                    </Link>
                                  </BreadcrumbLink>
                                </BreadcrumbItem>
                              ))
                            : ""}
                        </Breadcrumb>
                      </h3>
                      <Box
                        onClick={_showAlllist}
                        className="search_filter_close"
                      >
                        <Text>
                          <FontAwesomeIcon icon={faAngleDown}></FontAwesomeIcon>
                        </Text>
                      </Box>
                    </>
                  ) : (
                    <>
                      <h3 className="category_page_title">
                        <Breadcrumb
                          fontWeight="medium"
                          mt="1"
                          paddingBottom="4"
                        >
                          <BreadcrumbItem>
                            <BreadcrumbLink
                              className="category-nav__list"
                              href="/"
                            >
                              홈
                            </BreadcrumbLink>
                          </BreadcrumbItem>
                          {categoryInfo.length > 0
                            ? categoryInfo.map((el) => (
                                <BreadcrumbItem isCurrentPage>
                                  <BreadcrumbLink className="category-nav__list">
                                    <Link
                                      href={`/parts/mallcategory/${+el.id}`}
                                    >
                                      {el.name}
                                    </Link>
                                  </BreadcrumbLink>
                                </BreadcrumbItem>
                              ))
                            : ""}
                        </Breadcrumb>
                      </h3>
                      <Box
                        onClick={_showAlllist}
                        className="search_filter_close"
                      >
                        <FontAwesomeIcon icon={faAngleUp}></FontAwesomeIcon>
                      </Box>
                    </>
                  )
                ) : (
                  <h3 className="category_page_title">
                    <Breadcrumb fontWeight="medium" mt="1" paddingBottom="4">
                      <BreadcrumbItem>
                        <BreadcrumbLink className="category-nav__list" href="/">
                          홈
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      {categoryInfo.length > 0
                        ? categoryInfo.map((el) => (
                            <BreadcrumbItem isCurrentPage>
                              <BreadcrumbLink className="category-nav__list">
                                <Link href={`/parts/mallcategory/${+el.id}`}>
                                  {el.name}
                                </Link>
                              </BreadcrumbLink>
                            </BreadcrumbItem>
                          ))
                        : ""}
                    </Breadcrumb>
                  </h3>
                )}
              </Box>

              <List
                className={
                  "search_category_list " +
                  (isShow ? "overflow-hidden" : "overflow-show")
                }
              >
                {manufacturerGroup
                  ? manufacturerGroup.map((el) => (
                      <ListItem>
                        <Link
                          href={`/parts/mallcategory/${el.catg_code}`}
                          className="filter_company_name"
                        >
                          {el.catg_name}
                        </Link>
                      </ListItem>
                    ))
                  : ""}
              </List>
            </Box>
            <Box className="mallCategory-box">
              {block === true ? (
                <>
                  <Box>
                    <Box className="category-list-btn">
                      <ul>
                        <li>
                          <button
                            className={btnActive === "square" ? "active" : ""}
                            onClick={() => setBtnActive("square")}
                          >
                            <FontAwesomeIcon
                              className="datasheet_icon"
                              icon={faTable}
                            />{" "}
                          </button>
                        </li>
                        <li>
                          <button
                            className={btnActive === "list" ? "active" : ""}
                            onClick={() => setBtnActive("list")}
                          >
                            <FontAwesomeIcon
                              className="datasheet_icon"
                              icon={faBars}
                            />{" "}
                          </button>
                        </li>
                      </ul>
                    </Box>

                    <Box className="category_search_wrap">
                      <Box className="search_container_box">
                        <input
                          value={keyword}
                          onChange={saveKeyword}
                          placeholder="검색어를 입력하세요"
                          onKeyPress={OnEnter}
                          className="market_search_input"
                        />
                        <button onClick={searchKeyword}>조회</button>
                      </Box>
                    </Box>

                    <Box className="category-search">
                      <Text
                        className="category-counting"
                        display="flex"
                        marginBottom="10px"
                      >
                        총{" "}
                        <Text margin="0px 5px" color="red">
                          {totalCount.toLocaleString()}
                        </Text>
                        건
                      </Text>
                    </Box>

                    <>
                      {btnActive === "list" ? (
                        //  table / list 형식
                        <>
                          <Box className="mall_table list pc">
                            <ul>
                              {data
                                ? data.map((el) =>
                                    el.prices.length > 0 ? (
                                      <li className="mall_table_item">
                                        <Box className="mall_item_info">
                                          <Box className="mall_item_img">
                                            <Link
                                              onClick={() =>
                                                isShoppingmallOrCombineBot(
                                                  isLoginCheck,
                                                  el
                                                )
                                              }
                                              className="category_mall_img"
                                            >
                                              <Image
                                                src={
                                                  el.it_img1
                                                    ? el.it_img1
                                                    : el.it_img2
                                                    ? el.it_img2
                                                    : "/images/no_img.png"
                                                }
                                                width="100%"
                                                height="auto"
                                              />
                                            </Link>
                                          </Box>

                                          <Box className="mall_item_names">
                                            <Link
                                              onClick={() =>
                                                isShoppingmallOrCombineBot(
                                                  isLoginCheck,
                                                  el
                                                )
                                              }
                                            >
                                              <p>{el.it_brand}</p>
                                              <strong>{el.it_name}</strong>

                                              <span>{el.it_basic}</span>
                                            </Link>
                                          </Box>
                                        </Box>

                                        <Box className="mall_item_cnt">
                                          <>
                                            {el.it_soldout === 1 ? (
                                              <p className="category_mall_number">
                                                <b>재고</b>
                                                <span>0</span>
                                                <b className="unit">개</b>
                                              </p>
                                            ) : (
                                              <p className="category_mall_number">
                                                <b>재고</b>
                                                <span>
                                                  {el.it_stock_qty.toLocaleString()}{" "}
                                                </span>
                                                <b className="unit">개</b>
                                              </p>
                                            )}
                                          </>
                                        </Box>

                                        <Box className="mall_item_notice">
                                          <>
                                            {" "}
                                            {el.it_soldout === 2 ? (
                                              <Box>
                                                <p className="rightNow">
                                                  바로출고{" "}
                                                  <FontAwesomeIcon
                                                    icon={faTruck}
                                                  ></FontAwesomeIcon>
                                                </p>
                                                <p className="specialPrice">
                                                  특가제공{" "}
                                                  <FontAwesomeIcon
                                                    icon={faStar}
                                                  ></FontAwesomeIcon>
                                                </p>
                                              </Box>
                                            ) : (
                                              <Box className="mall_item_prices">
                                                <p className="price_before">
                                                  ₩
                                                  <span>
                                                    {el.prices[0].it_price_before.toLocaleString()}
                                                  </span>
                                                </p>
                                                <p className="price_after">
                                                  할인가 : ₩
                                                  <span>
                                                    {el.prices[0].it_price.toLocaleString()}
                                                  </span>
                                                </p>
                                              </Box>
                                            )}
                                          </>
                                        </Box>

                                        <Box className="mall_item_btns">
                                          {el.it_origin === null ||
                                          el.it_origin === "null" ||
                                          el.it_origin === "" ||
                                          el.it_origin === undefined ||
                                          el.it_origin === "undefined" ? (
                                            <Box className="data_sheet non">
                                              <Link
                                                // href={el.it_origin}
                                                isExternal="true"
                                              >
                                                <FontAwesomeIcon
                                                  className="datasheet_icon"
                                                  icon={faFilePdf}
                                                />
                                                데이터시트
                                              </Link>
                                            </Box>
                                          ) : (
                                            <Box className="data_sheet">
                                              <Link
                                                href={el.it_origin}
                                                isExternal="true"
                                              >
                                                <FontAwesomeIcon
                                                  className="datasheet_icon"
                                                  icon={faFilePdf}
                                                />
                                                데이터시트
                                              </Link>
                                            </Box>
                                          )}
                                          <Box className="buy_btn">
                                            {el.it_soldout === 1 ? (
                                              <a
                                                className="back_order"
                                                href={`/parts/mallview/${el.it_id}`}
                                              >
                                                Back-Order
                                              </a>
                                            ) : el.it_soldout === 2 ? (
                                              <Box
                                                className="quote"
                                                onClick={() =>
                                                  combineBotAsked(
                                                    isLoginCheck,
                                                    el
                                                  )
                                                }
                                              >
                                                판다봇 견적요청
                                              </Box>
                                            ) : (
                                              <a
                                                className="cart"
                                                href={`/parts/mallview/${el.it_id}`}
                                              >
                                                구매하기
                                              </a>
                                            )}
                                          </Box>
                                        </Box>
                                      </li>
                                    ) : (
                                      ""
                                    )
                                  )
                                : ""}
                            </ul>
                          </Box>
                        </>
                      ) : btnActive === "square" ? (
                        // grid 형식

                        <>
                          <Box className="grid mallCategory-list_container">
                            <Box className="mallCategory-list_wrap">
                              {data
                                ? data.map((el) =>
                                    el.prices.length > 0 ? (
                                      <Box className="mallCategory-grid_product">
                                        <Link
                                          onClick={() =>
                                            isShoppingmallOrCombineBot(
                                              isLoginCheck,
                                              el
                                            )
                                          }
                                          className="mallCategory-grid_product_img"
                                        >
                                          {" "}
                                          <Image
                                            src={
                                              el.it_img1
                                                ? el.it_img1
                                                : el.it_img2
                                                ? el.it_img2
                                                : "/images/no_img.png"
                                            }
                                          />
                                        </Link>
                                        <Box className="mallCategory-grid_content">
                                          <Text className="mallCategory-grid_product_name">
                                            <span> {el.it_brand}</span>
                                            <span>{el.it_name}</span>
                                            <span>{el.it_basic}</span>
                                            <a></a>
                                          </Text>
                                          <Text className="mallCategory-grid_product_number">
                                            {el.it_soldout === 1 ? (
                                              <span>재고 0 개</span>
                                            ) : (
                                              <span>
                                                재고{" "}
                                                {el.it_stock_qty.toLocaleString()}
                                                개
                                              </span>
                                            )}

                                            {el.it_soldout === 2 ? (
                                              <Box className="category_mall_phase">
                                                <span className="category_right_now">
                                                  바로출고
                                                </span>
                                                <span className="category_special_suggest">
                                                  특가제공
                                                </span>
                                              </Box>
                                            ) : (
                                              <>
                                                {" "}
                                                <span
                                                  className="category_price_before"
                                                  style={{
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  ₩
                                                  {el.prices[0].it_price_before.toLocaleString()}
                                                </span>
                                                <span>
                                                  할인가: ₩
                                                  {el.prices[0].it_price.toLocaleString()}
                                                </span>
                                              </>
                                            )}
                                          </Text>
                                        </Box>
                                        <Box className="category_mall_btns grid">
                                          {el.it_origin === null ||
                                          el.it_origin === "null" ||
                                          el.it_origin === "" ||
                                          el.it_origin === undefined ||
                                          el.it_origin === "undefined" ? (
                                            <Link
                                              href={el.it_origin}
                                              isExternal="true"
                                              className="category_data_sheet non_sheet"
                                            >
                                              <Box className="flex-center">
                                                <FontAwesomeIcon
                                                  className="datasheet_icon"
                                                  icon={faFilePdf}
                                                />
                                                데이터시트
                                              </Box>
                                            </Link>
                                          ) : (
                                            <Link
                                              href={el.it_origin}
                                              isExternal="true"
                                              className="category_data_sheet"
                                            >
                                              <Box className="flex-center">
                                                <FontAwesomeIcon
                                                  className="datasheet_icon"
                                                  icon={faFilePdf}
                                                />
                                                데이터시트
                                              </Box>
                                            </Link>
                                          )}
                                          {el.it_soldout === 1 ? (
                                            <a
                                              className="category_link_back"
                                              href={`/parts/mallview/${el.it_id}`}
                                            >
                                              Back-Order
                                            </a>
                                          ) : el.it_soldout === 2 ? (
                                            <Box
                                              className="category_link_quote"
                                              onClick={() =>
                                                combineBotAsked(
                                                  isLoginCheck,
                                                  el
                                                )
                                              }
                                            >
                                              판다봇 견적요청
                                            </Box>
                                          ) : (
                                            <a
                                              className="category_link_buy"
                                              href={`/parts/mallview/${el.it_id}`}
                                            >
                                              구매하기
                                            </a>
                                          )}
                                        </Box>
                                      </Box>
                                    ) : (
                                      ""
                                    )
                                  )
                                : ""}
                            </Box>
                          </Box>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                    <></>
                  </Box>
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={perPage}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={5}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                    onChange={handlePageChange}
                  />
                </>
              ) : (
                <Box>
                  <Box className="category-list-btn"></Box>
                  <Box className="category_search_wrap">
                    <Box className="search_container_box">
                      <input
                        value={keyword}
                        onChange={saveKeyword}
                        placeholder="검색어를 입력하세요"
                        onKeyPress={OnEnter}
                        className="market_search_input"
                      />
                      <button onClick={searchKeyword}>조회</button>
                    </Box>
                  </Box>

                  <Box className="category-search">
                    <Text
                      className="category-counting"
                      display="flex"
                      marginBottom="10px"
                    >
                      총{" "}
                      <Text margin="0px 5px" color="red">
                        0
                      </Text>
                      건
                    </Text>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        {/* ============ 검색결과 데이터가 없을때  ============*/}
        <Box className={noneSearchShow ? "search" : "search-hidden"}>
          <Center>
            <Box className="noneSearch">
              <Image className="noneSearch-img" src="/images/warning 1.png" />
              <Text className="noneSearch-result">등록된 제품이 없습니다.</Text>
            </Box>
          </Center>
        </Box>
      </Box>
    </BaseLayout>
  );
}
